import React from 'react';
import { useTranslation } from 'react-i18next';
import { FilterMinimalStyleCircle88 } from 'shared/assets/icons';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './no-filter-results-state.style';

export type NoFilterResultsStateProps = {
  onReset?: () => void;
  dense?: boolean;
};

export const NoFilterResultsState: React.FC<NoFilterResultsStateProps> = ({
  onReset,
  dense = false,
}) => {
  const { t } = useTranslation();
  const _onReset = () => onReset?.();

  return (
    <Styled.NoFilterStateContainer $dense={dense}>
      <Styled.IconContainer $dense={dense}>
        <Icon icon={FilterMinimalStyleCircle88} />
      </Styled.IconContainer>
      <Styled.Title>
        {t('views.tasks-list.no-filter-results-state')}
      </Styled.Title>
      {!!onReset && (
        <Button
          onClick={_onReset}
          variant={Variants.Text}
          size={Sizes.Medium}
          color={Colors.Primary}
        >
          {t('views.tasks-list.clear-filters')}
        </Button>
      )}
    </Styled.NoFilterStateContainer>
  );
};
